import { DomainService } from 'src/app/features/domain/services/domain.service';
import { environment } from 'src/environments/environment';

let apiUrl: string = ''; // Inicializamos la variable apiUrl con una cadena vacía



// Exportamos una función que devuelva la URL de la API
export async function getApiUrl(): Promise<string> {
  const apiUrl = await DomainService.getApiUrl();
  environment.apiUrl = apiUrl;
  return apiUrl;
}



// Aquí puedes acceder a otras constantes
export const API_TOKEN: any = localStorage.getItem('token');
export const USER_INFO: any = localStorage.getItem('userInfo');
export const USER_REGISTER_INFO: any = localStorage.getItem('userRegisterInfo');

export const API_URL_NO_V1: string = 'https://siep.elpobladosa.com:9028/api/';
